import styled from "styled-components";

export const TextAbout = styled.h3`
    color: #707070;
    font-size: 13px;
    margin-left: 5px;
`;